import React from 'react';
import ParticipantsTable from '@/features/dashboard/participants/components/ParticipantsTable.tsx';

const ParticipantsPage = () => {
  return <ParticipantsTable />;
};

export default ParticipantsPage;
